import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';

import { NodeHotKey } from 'libs/editor/plugins/helpers/nodeHotKey';
import { RenderNode } from 'libs/editor/plugins/helpers/renderNode';

const OrderedListNode = observer(({ attributes, children }) => (
  <OL {...attributes}>{children}</OL>
));

const type = 'ordered_list';

export function OrderedList(listPlugin) {
  const active = value =>
    listPlugin.utils.isSelectionInList(value) &&
    listPlugin.utils.getCurrentList(value).type === type;
  return {
    button: {
      elementType: 'node',
      type,
      active,
      handleClick: store => {
        const { value, reference, onChange } = store;
        if (active(value)) {
          listPlugin.changes.unwrapList(reference, type);
        } else {
          listPlugin.changes.wrapInList(reference, type);
        }
        onChange(reference);
      },
    },
    plugins: [
      NodeHotKey({ key: '-', type }),
      RenderNode(type, props => <OrderedListNode {...props} />),
      listPlugin,
    ],
  };
}

const OL = styled.ol`
  margin-top: 5px;
  margin-bottom: 10px;
  padding-left: ${props => props.theme.spacing.large};
`;
